module.exports = __webpack_public_path__ + "img/3.170917ea.jpg";